// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"style_searchInput__16iTZ","input":"style_input__3ZhK2","searchResult":"style_searchResult__3yrV5"};